import type { NpsThemeClasses } from "../types";

export function getNpsThemeClasses(): NpsThemeClasses {
  return {
    title: "text-white",
    description: "text-gray-100",
    label: "text-gray-100",
    container:
      "bg-teal-1000 rounded-[16px] border border-[rgba(255,255,255,0.09)] backdrop-blur-[12.5px]",
    buttonUnselected:
      "bg-[rgba(255,255,255,0.09)] text-gray-100 border-2 border-transparent hover:bg-[rgba(255,255,255,0.15)]",
    textarea:
      "bg-[rgba(255,255,255,0.09)] border-2 border-transparent focus:border-teal-700 text-white placeholder:text-gray-300",
    focusRingOffset: "focus:ring-offset-teal-1000",
    scoreSelected: "bg-teal-700 text-white border-teal-700",
    tertiary:
      "text-teal-700 text-[15px] leading-[22px] tracking-[1.5px] uppercase",
  };
}
